import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { MasterData, SecurityData } from '../shared/index';
import MenuAndLogo from './MenuAndLogo';
import { TopHeader } from './TopHeader';

import * as firebase from 'firebase' ;

export interface MainHeaderProps extends BaseComponentProps { 
  // hendlingUserLogout: () => any;
  lang: string;
  currency: string; 
  user_login: boolean;
  user: SecurityData.ApplicationUser;
  currencyChange: (currencyCode: string) => any;
  topHeaderData: {
    socialMedia: MasterData.SocialMedia[],
    companyInfo: MasterData.CompanyInfo;
  }; 
  languageChange: (lang: string) => any;
  userDialogOpen: boolean;
  hengleUserDialogClose: () => any;
  accountHandleClick: () => any;
  wishlistCount: number;
  changeCurrency: boolean;
  history: History | any;
  userAccess: string;

	firebaseApp: firebase.app.App ; 
}
export interface MainHeaderState extends BaseComponentState { }

export class MainHeader extends BaseComponent<MainHeaderProps, MainHeaderState> {
  render() {
    if (this.state.haveReactError) {
      return this.renderErrorPanel();
    }
    return (
      <header id="mainHeader" className="">
        <TopHeader key={`top${this.props.lang}-${this.props.currency}`} lang={this.props.lang} />
        <MenuAndLogo
          firebaseApp={this.props.firebaseApp}
          lang={this.props.lang} 
          languageChange={this.props.languageChange}
          currency={this.props.currency} 
          user={this.props.user}
          currencyChange={this.props.currencyChange}
          user_login={this.props.user_login}
          hengleUserDialogClose={this.props.hengleUserDialogClose}
          userDialogOpen={this.props.userDialogOpen}
          accountHandleClick={this.props.accountHandleClick}
          wishlistCount={this.props.wishlistCount}
          changeCurrency={this.props.changeCurrency}
          history={this.props.history}
          userAccess={this.props.userAccess}
        />
      </header>
    );
  }
}

/**
 * 
 * <TopHeader data={this.props.topHeaderData} lang={this.props.lang} />
 */


// WEBPACK FOOTER //
// ./src/header/MainHeader.tsx